export default function useAuthUser() {
    const user = JSON.parse(localStorage.getItem('authUser'));
    const isLogged = user ? true : false;
    return { user, isLogged };
}